import { makeStyles } from '@material-ui/core/styles';
import {
  MODAL_MAX_WIDTH,
  MODAL_WIDTH,
  MODAL_MAX_HEIGHT,
  MODAL_PADDING,
  PAPER_PADDING,
  ICON_MARGIN_RIGHT,
  DEFAULT_METRIC_COLOR
} from '../constants/primitive-metrics.constants';

export const useMetricModalStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    maxWidth: MODAL_MAX_WIDTH,
    width: MODAL_WIDTH,
    maxHeight: MODAL_MAX_HEIGHT,
    overflow: 'auto',
    padding: MODAL_PADDING,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  title: {
    fontWeight: 'bold',
  },
  metricPaper: {
    padding: PAPER_PADDING,
  },
  metricContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  metricIcon: {
    color: DEFAULT_METRIC_COLOR,
    marginRight: ICON_MARGIN_RIGHT,
  },
  metricValue: {
    fontWeight: 'bold',
  },
}));
